import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c482a4d2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c482a4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c482a4d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c482a4d2')) {
      api.createRecord('c482a4d2', component.options)
    } else {
      api.reload('c482a4d2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c482a4d2&scoped=true&", function () {
      api.rerender('c482a4d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/giftCodeManage/giftCodeLevel/index.vue"
export default component.exports